import {
  __,
  arrayof,
  data,
  discriminated,
  enumvalue,
  isany,
  isboolean,
  isdata,
  isstring,
} from "@deckchair-technicians/vice";

@data
export class RealFlynotesServerConfig {
  type: "real" = "real";
  url = __(isstring());
  developments: [
    {
      url: string;
      licenseKey: string;
    }
  ];
}

@data
export class StubFlynotesServerConfig {
  type: "stub" = "stub";
}

export type FlynotesServerConfig =
  | RealFlynotesServerConfig
  | StubFlynotesServerConfig;

export enum Environment {
  prod = "prod",
  local = "local",
}

@data
export class RollbarLoggingConfig {
  type: "rollbar" = "rollbar";
  accessToken = __(isstring());
}

@data
export class StubLoggingConfig {
  type: "stub" = "stub";
}

export type LoggingConfig = RollbarLoggingConfig | StubLoggingConfig;

@data
export class RealSqsConfig {
  type: "real" = "real";
}

@data
export class StubSqsConfig {
  type: "stub" = "stub";
}

export type SqsConfig = RealSqsConfig | StubSqsConfig;

@data
export class ConnectionStringConnectionDetails {
  connectionString: string = __(isstring());
}

@data
export class FullConnectionDetails {
  server: string = __(isstring());
  user: string = __(isstring());
  password: string = __(isstring());
  database: string = __(isstring());
}

@data
export class Config {
  migrateDb: boolean = __(isboolean());

  sqlLibraryName: string = __(isstring());

  npmCommand: string = __(isstring());
  packageJsonPath: string = __(isstring());

  connectionParams: (
    | ConnectionStringConnectionDetails
    | FullConnectionDetails
  )[] = __(
    arrayof(
      isdata(FullConnectionDetails).or(
        isdata(ConnectionStringConnectionDetails)
      )
    )
  );

  environment: Environment = __(enumvalue(Environment));

  sqs: SqsConfig = __(discriminated<SqsConfig>(RealSqsConfig, StubSqsConfig));

  flynotesServer: FlynotesServerConfig = __(
    discriminated<FlynotesServerConfig>(
      RealFlynotesServerConfig,
      StubFlynotesServerConfig
    )
  );
  logging: LoggingConfig = __(
    discriminated<LoggingConfig>(RollbarLoggingConfig, StubLoggingConfig)
  );
}

const prodConfig: Config = {
  npmCommand: "node\\npm",
  packageJsonPath: "node_modules/@flynotes/carestream-server/package.json",

  environment: Environment.prod,

  migrateDb: false,

  sqlLibraryName: "mssql/msnodesqlv8",

  // Use windows authentication on a real SOE server
  // Attempt to support Sql Server 2005/2008/2012
  connectionParams: [
    {
      connectionString:
        "Server=.;Database=sys2000;Driver={SQL Server Native Client 11.0};Uid=sa;Pwd=Flyn0tes!;",
    },
    {
      connectionString:
        "Server=.;Database=sys2000;Driver={SQL Server Native Client 10.0};Uid=sa;Pwd=Flyn0tes!;",
    },
    {
      connectionString:
        "Server=.;Database=sys2000;Driver={SQL Server Native Client 9.0};Uid=sa;Pwd=Flyn0tes!;",
    },
  ],

  flynotesServer: {
    type: "real",
    url: process.env["DEVELOPMENT_MODE"]
      ? "https://flynotes.dev.myflynotes.com"
      : // : "https://flynotes.dev.myflynotes.com",
        "https://app.myflynotes.com",
    developments: [
      {
        url: "https://flynotes.dev.myflynotes.com",
        licenseKey: "b10aa6c7-6c9b-465a-a62d-668aca565634",
      },
    ],
  },

  logging: {
    type: "rollbar",
    accessToken: "89f86f53ee9e432e96ca63952d6d3f11",
  },

  sqs: { type: "real" },
};

const localConfig: Config = {
  npmCommand: "npm",
  packageJsonPath: "package.json",

  environment: Environment.local,

  migrateDb: true,

  sqlLibraryName: "mssql",
  connectionParams: [
    {
      server: "localhost",
      user: "sa",
      password: "Flyn0tes!",
      database: "sys2000",
    },
  ],

  flynotesServer: {
    type: "real",
    url: "http://localhost:3000",
    developments: [
      {
        url: "https://flynotes.dev.myflynotes.com",
        licenseKey: "b10aa6c7-6c9b-465a-a62d-668aca565634",
      },
    ],
  },

  logging: {
    type: "stub",
  },

  sqs: { type: "stub" },
};

export const getConfig = (environment: Environment): Config => {
  switch (environment) {
    case Environment.local:
      return localConfig;
    case Environment.prod:
      return prodConfig;
  }
};
